import { useEffect, useState } from "react";
import type { Snapshot, Whisper } from "@earpiece/contracts";

export function Overlay({ endpoint = "/overlay/events" }: { endpoint?: string }) {
  const [snapshot, setSnapshot] = useState<Snapshot>({ connection: "idle", pipelineMode: "rules", scene: "", queue: [], collecting: 0 });
  useEffect(() => {
    const events = new EventSource(endpoint, { withCredentials: true });
    events.addEventListener("snapshot", (event) => setSnapshot(JSON.parse((event as MessageEvent).data) as Snapshot));
    return () => events.close();
  }, [endpoint]);
  const active = snapshot.queue.find((item) => item.status === "speaking") ?? snapshot.queue[0];
  return <main className="overlay-shell">
    <section className={`whisper-card ${active?.kind ?? "empty"}`}>
      <div className="signal"><span /> EARPIECE · {label(snapshot, active)}</div>
      {active ? <>
        <p className="brief">{active.brief}</p>
        <p className="meta">{active.uniqueChatters} {active.uniqueChatters === 1 ? "chatter" : "chatters"} · {active.messageCount} {active.messageCount === 1 ? "message" : "messages"}</p>
      </> : <p className="brief muted">Listening to chat…</p>}
    </section>
  </main>;
}

function label(snapshot: Snapshot, whisper?: Whisper) {
  if (snapshot.connection === "reconnecting" || snapshot.connection === "degraded") return "RECONNECTING";
  if (snapshot.pipelineMode === "rules") return "RULES MODE";
  if (!whisper) return `COLLECTING ${snapshot.collecting}`;
  if (whisper.status === "spoken") return "HEARD";
  if (whisper.status === "speaking") return "SPEAKING";
  return whisper.interrupt ? "MOD ALERT" : "QUEUED";
}

